import { render, staticRenderFns } from "./ConfirmDeleteEditorialPosts.vue?vue&type=template&id=d9fa61f2&scoped=true&"
import script from "./ConfirmDeleteEditorialPosts.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteEditorialPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fa61f2",
  null
  
)

export default component.exports